<div class="request-detail-container" *ngIf="request; else noSelection">
  <div class="customer-section">
    <div class="customer-header">
      <div class="customer-name">{{ request.customer_name }}</div>
      <div class="reservation-badge">
        <div class="immediate-badge">HEMEN</div>
        <div class="reservation-label">REZERVASYON</div>
      </div>
    </div>
    <div class="customer-phone">
      <svg class="phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path
          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
      <span>{{ getPhoneNumber() }}</span>
    </div>
    <div class="request-meta">
      <span class="meta-label">Talep Oluşturma Tarihi:</span>
      <span class="meta-date">{{ formatDate(request.created_at) }}</span>
      <span class="meta-time">{{ formatTime(request.created_at) }}</span>
    </div>
    <div *ngIf="hasAutomaticMessageSent()" class="auto-message-info">
      <span class="auto-message-title">Otomatik Mesaj Gönderildi</span>
      <span class="auto-message-detail">
        {{ formatDate(request.response_sent_at) }} {{ formatTime(request.response_sent_at) }}
      </span>
    </div>
  </div>

  <div class="location-section">
    <div class="location-card">
      <div class="location-header">
        <svg class="location-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        <div class="location-label">MÜŞTERİ KONUMU</div>
        <div class="request-language-badge" *ngIf="request.language">
          {{ request.language | uppercase }}
        </div>
      </div>
      <div class="location-value">{{ getLocation() }}</div>
    </div>
  </div>

  <div class="quick-response-section">
    <div class="quick-response-header">
      <div class="lightning-icon-wrapper">
        <svg class="lightning-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
      </div>
      <div class="quick-response-title">
        <div class="title-main">Hızlı Yanıt & Aksiyon</div>
        <div class="title-description">Seçilen süre misafire Whatsapp üzerinden iletilecektir.</div>
      </div>
    </div>
    <div class="quick-response-buttons">
      <button class="response-btn" [disabled]="!isSystemOpen || isSystemBusy || isLoading" [class.loading]="isLoading"
        (click)="onQuickResponse(5)">
        <div class="response-time">5 dk</div>
        <div class="response-subtitle">İçinde Dönüş</div>
      </button>
      <button class="response-btn" [disabled]="!isSystemOpen || isSystemBusy || isLoading" [class.loading]="isLoading"
        (click)="onQuickResponse(10)">
        <div class="response-time">10 dk</div>
        <div class="response-subtitle">İçinde Dönüş</div>
      </button>
      <button class="response-btn" [disabled]="!isSystemOpen || isSystemBusy || isLoading" [class.loading]="isLoading"
        (click)="onQuickResponse(15)">
        <div class="response-time">15 dk</div>
        <div class="response-subtitle">İçinde Dönüş</div>
      </button>
    </div>
    <div *ngIf="!isSystemOpen || isSystemBusy" class="system-closed-warning">
      <p *ngIf="!isSystemOpen">⚠️ Sistem kapalı olduğu için talep onaylama mümkün değildir.</p>
      <p *ngIf="isSystemBusy && isSystemOpen">⚠️ Sistem meşgul modunda olduğu için talep onaylama mümkün değildir.</p>
    </div>
  </div>
</div>

<ng-template #noSelection>
  <div class="no-selection">
    <p>Bir talep seçin</p>
  </div>
</ng-template>

<app-dialog *ngIf="showDialog" [config]="dialogConfig" (close)="onDialogClose()" (confirm)="onDialogClose()">
</app-dialog>